import api from '.';

export const login = async (email, password) => {
  try {
    const res = await api.post('/api/auth/login', { email, password });
    const { token, user } = res.data;

    localStorage.setItem('token', token);
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('user', JSON.stringify(user));

    return res.data;
  } catch (error) {
    console.error('Login API Error:', error.response?.data || error.message);
    throw error;
  }
};

export const getProfile = async () => {
  try {
    const res = await api.get('/api/auth/profile');
    return res.data;
  } catch (error) {
    console.error('Get Profile API Error:', error.response?.data || error.message);
    throw error;
  }
};

export const logout = async () => {
  try {
    await api.post('/api/auth/logout');
  } catch (error) {
    console.error('Logout API Error:', error);
  } finally {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';
  }
};

export const forgotPassword = async (payload) => {
  try {
    const res = await api.post("/api/auth/forgot-password", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Forgot Password API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};

export const resetPasswordWithOtp = async (payload) => {
  try {
    const res = await api.post("/api/auth/reset-password-otp", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Reset Password OTP API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
      headers: error.response?.headers,
    });
    throw error;
  }
};